export enum EAuthenticationTypes {
  "SIGNUP" = "SIGNUP",
  "LOGIN" = "LOGIN",
}

export type TAuthenticationProps = {
  authType: EAuthenticationTypes;
  isEmbedded: boolean;
};
